import { formatISO } from 'date-fns';
import { z } from 'zod';

import { nullishString } from '../../utils/schema';

const dateString = z.string().trim().date();
const today = () => formatISO(new Date(), { representation: 'date' });

export const FarbroBulkDonorScheduleRowSchema = z.object({
  donorNameToMatch: z.string().trim().min(1).max(41),
  donorRegistrationNumber: z.string().trim().min(1).max(20),
  birthDate: dateString.refine((value) => value <= today(), {
    message: 'Birth date cannot be in the future',
  }),
  donorBreed: z.string().trim().min(1),
  location: z
    .preprocess(
      (value) =>
        typeof value === 'string' ? value.trim().toLowerCase() : value,
      z.enum(['exum', 'hartley']),
    )
    .transform((value) => (value === 'exum' ? 'Exum' : 'Hartley')),
  opuDate: dateString.refine((value) => value >= today(), {
    message: 'OPU date cannot be in the past',
  }),
  naab: nullishString({ max: 10 }),
  sire: nullishString(),
  semenType: nullishString(),
  collectionCode: nullishString(),
  priority: z.string().trim().min(1),
  donorResolution: z
    .enum(['USE_EXISTING', 'CREATE_NEW'])
    .nullish()
    .transform((value) => value ?? null),
  gradeInstruction: z
    .enum(['g1-g2', 'g1-g2-g3', 'freeze-dt-g1-g2'])
    .nullish()
    .transform((value) => value ?? null),
  matingClassification: z
    .enum(['angus', 'holstein', 'crossbred', 'jersey'])
    .nullish()
    .transform((value) => value ?? null),
});

export const FarbroBulkDonorScheduleRowsSchema = z.array(
  FarbroBulkDonorScheduleRowSchema.nullish().transform((row) => row ?? null),
);

export type FarbroBulkDonorScheduleInput = z.infer<
  typeof FarbroBulkDonorScheduleRowSchema
>;
